<template>
  <!-- Este componente queda a modo de ejemplo -->
  <div
    class="h-screen bg-right bg-cover pb-14"
    style="background-image:url('bg.svg');"
  >
    <!--Nav-->
    <div class="container w-full p-6 mx-auto">
      <div class="flex items-center justify-between w-full">
        <a
          class="flex items-center text-2xl font-bold text-indigo-400 no-underline hover:no-underline lg:text-2xl"
          href="#"
        >
          <svg
            class="h-12 pr-2 text-indigo-600 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
            />
          </svg>
          <span class="ml-2 text-2xl font-extrabold lg:text-4xl">Happer</span>
        </a>
      </div>
    </div>

    <!--Main-->
    <div
      class="container flex flex-col flex-wrap items-center px-6 pt-24 mx-auto md:pt-48 md:flex-row"
    >
      <!--Left Col-->
      <div
        class="flex flex-col justify-center w-full overflow-y-hidden xl:w-2/5 lg:items-start"
      >
        <h1
          class="my-4 text-3xl font-bold leading-tight text-center text-purple-800 md:text-5xl md:text-left slide-in-bottom-h1"
        >
          Main Hero Message to sell your app
        </h1>
        <p
          class="mb-8 text-base leading-normal text-center md:text-2xl md:text-left slide-in-bottom-subtitle"
        >
          Sub-hero message, not too long and not too short. Make it just right!
        </p>

        <p
          class="pb-8 font-bold text-center text-blue-400 lg:pb-6 md:text-left fade-in"
        >
          Download our app:
        </p>
        <div
          class="flex justify-center w-full pb-24 md:justify-start lg:pb-0 fade-in"
        >
          <img src="App Store.svg" class="h-12 pr-4 bounce-top-icons" />
          <img src="Play Store.svg" class="h-12 bounce-top-icons" />
        </div>
      </div>

      <!--Right Col-->
      <div class="w-full py-6 overflow-y-hidden xl:w-3/5">
        <img class="w-5/6 mx-auto lg:mr-0 slide-in-bottom" src="devices.svg" />
      </div>

      <!--Footer-->
      <div class="w-full pt-16 pb-6 text-sm text-center md:text-left fade-in">
        <a class="text-gray-500 no-underline hover:no-underline" href="#"
          >&copy; App 2019</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
